import React from 'react';
import PropTypes from 'prop-types';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import styles from './DownloadNotification.module.css';

const DownloadNotification = ({ onDismiss, onAccept }) => (
  <div className={styles.downloadNotification}>
    <div className={styles.container}>
      <h2>
        Would you like to download a CSV of the successfully created products?
      </h2>
      <div className={styles.buttons}>
        <Button
          buttonType={BUTTON_TYPES.PRIMARY_INVERSE}
          style={{ width: 153, borderWidth: 1 }}
          onClick={onDismiss}
        >
          No, dismiss
        </Button>
        <Button
          buttonType={BUTTON_TYPES.PRIMARY}
          style={{ width: 196 }}
          onClick={onAccept}
        >
          Yes, download
        </Button>
      </div>
    </div>
  </div>
);

DownloadNotification.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default DownloadNotification;
